export const PREFLIGHT_CHECK_LABELS: Record<
  string,
  { label: string; description: string; blocking: boolean }
> = {
  'required-data-fields': {
    label: 'Required data fields present',
    description: 'All data fields the selected playbook needs are configured on this shop.',
    blocking: true,
  },
  'no-conflicting-experiment': {
    label: 'No other running experiment on the same surface',
    description: 'Only one experiment can run at a time.',
    blocking: true,
  },
  'allocation-totals-100': {
    label: 'Allocation totals 100',
    description: 'Production, Control and Variant traffic must add up to 100%.',
    blocking: true,
  },
  'catalogue-freshness': {
    label: 'Catalogue freshness',
    description: 'Your catalogue was synced recently enough to trust these results.',
    blocking: false,
  },
  'traffic-sufficient': {
    label: 'Traffic sufficient for the chosen MDE',
    description: 'Enough daily test users to detect the minimum effect you set.',
    blocking: false,
  },
  'single-lever': {
    label: 'Single lever',
    description: 'Only one change per experiment keeps the result attributable.',
    blocking: false,
  },
};
